import '@Application/Bootstrap';

import autoload from '@123/druid/dist/Framework/Decorators/Autoload';
import component from '@123/druid/dist/Framework/Decorators/Component';
import {inject} from '@123/druid/dist/Framework/Decorators/Inject';
import View from '@123/druid/dist/Framework/View/View';
import AidenAdvisorView from '@Component/Aiden/AidenAdvisorView';
import AnimateToAnchor from '@Component/AnimateToAnchor/AnimateToAnchor';
import QuickFilter from '@Module/Group/Component/QuickFilter/QuickFilter';

@autoload
@component
export default class GroupIndexModuleView extends View {
    constructor(@inject(QuickFilter) quickFilter: QuickFilter, @inject(AnimateToAnchor) animateToAnchor: AnimateToAnchor) {
        super();

        this.register(quickFilter);
        this.register(animateToAnchor);
    }

    protected mounted(): void {
        this.getViews(AidenAdvisorView);
    }
}
